module.exports = __webpack_public_path__ + "static/img/759.486d5a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/759.jpg
// module id = B3ZH
// module chunks = 0